import request from '@/utils/request'

/**
 * 登录
 * @param data
 */
export function login (data) {
    return request({
        url: 'login',
        method: 'post',
        data
    })
}
/**
 * 退出
 * @param data
 */
export function logout (data) {
    return request({
        url: 'logout',
        method: 'post',
        data
    })
}

/*
部门相关接口
 */
export function department_list (data) {
    return request({
        url: 'company/department',
        method: 'get',
        params: data
    })
}



/*
部门员工相关接口
 */
export function department_member_list (data) {
    return request({
        url: 'company/dep_member_lst',
        method: 'get',
        params: data
    })
}


export function department_member_manager(data){

    return request({
        url: 'company/department_member_manager',
        method: 'post',
        data
    })
}

export function department_member_del(data){

    return request({
        url: 'company/department_member_del',
        method: 'post',
        data
    })
}


/*
小组相关接口
 */

export function team_list (data) {
    return request({
        url: 'company/team',
        method: 'get',
        params: data
    })
}

export function team_manager (data) {
    return request({
        url: 'company/team_manager',
        method: 'post',
        data
    })
}

export function team_del (data) {
    return request({
        url: 'company/team_del',
        method: 'post',
        data
    })
}


export function team_department_list (data) {
    return request({
        url: 'company/department_member_list',
        method: 'get',
        params: data
    })
}

export function team_member_list (data) {
    return request({
        url: 'company/team_member',
        method: 'get',
        params: data
    })
}
export function team_member_manager (data) {
    return request({
        url: 'company/set_depMember',
        method: 'post',
        data
    })
}
export function team_member_del (data) {
    return request({
        url: 'company/team_member_del',
        method: 'post',
         data
    })
}

export function set_team_member (data) {
    return request({
        url: 'company/set_depMember',
        method: 'get',
        params: data
    })
}
/*
 目标金额接口
 */

export function target_list (data) {
    return request({
        url: 'company/target',
        method: 'get',
        params: data
    })
}
export function target_manager (data) {
    return request({
        url: 'company/target_manager',
        method: 'post',
        data
    })
}
export function target_del (data) {
    return request({
        url: 'company/target_del',
        method: 'post',
        data
    })
}
export function team_target (data) {
    return request({
        url: 'company/team_target',
        method: 'get',
        params:data
    })
}
export function team_target_manager (data) {
    return request({
        url: 'company/team_target_manager',
        method: 'post',
        data
    })
}
/*
需求相关接口
 */
export function needs_list (data) {
    return request({
        url: 'system/needs',
        method: 'get',
        params: data
    })
}

export function needs_manager (data) {
    return request({
        url: 'system/needs_manager',
        method: 'post',
        data
    })
}

export function needs_del (data) {
    return request({
        url: 'system/needs_del',
        method: 'post',
        data
    })
}


/*
行业相关接口
 */
export function industry_list (data) {
    return request({
        url: 'system/industry',
        method: 'get',
        params: data
    })
}

export function industry_manager (data) {
    return request({
        url: 'system/industry_manager',
        method: 'post',
        data
    })
}

export function industry_del (data) {
    return request({
        url: 'system/industry_del',
        method: 'post',
        data
    })
}

/*
客户类型相关接口
 */
export function customer_type_list (data) {
    return request({
        url: 'system/customer_type',
        method: 'get',
        params: data
    })
}

export function customer_type_manager (data) {
    return request({
        url: 'system/customer_type_manager',
        method: 'post',
        data
    })
}

export function customer_type_del (data) {
    return request({
        url: 'system/customer_type_del',
        method: 'post',
        data
    })
}



/*
客户来源相关接口
 */
export function customer_source_list (data) {
    return request({
        url: 'system/customer_source',
        method: 'get',
        params: data
    })
}

export function source_manager (data) {
    return request({
        url: 'system/source_manager',
        method: 'post',
        data
    })
}

export function source_del (data) {
    return request({
        url: 'system/source_del',
        method: 'post',
        data
    })
}
export function source_indexs(data) {
    return request({
        url: 'system/source_indexs',
        method: 'get',
        params: data
    })
}


/*
成交类型相关接口
 */
export function transaction_type_list (data) {
    return request({
        url: 'system/transaction_type',
        method: 'get',
        params: data
    })
}

export function transaction_type_manager (data) {
    return request({
        url: 'system/transaction_type_manager',
        method: 'post',
        data
    })
}
// 成交方式
export function transaction_type_del (data) {
    return request({
        url: 'system/transaction_type_del',
        method: 'post',
        data
    })
}
// 同步成交方式
export function async_data (data) {
    return request({
        url: 'system/async_data',
        method: 'post',
        data
    })
}

export function modify_data_pwd (data) {
    return request({
        url: 'company/set_password',
        method: 'post',
        data
    })
}


// 任务目标下拉
export function target_select(data) {
    return request({
        url: 'company/target_select',
        method: 'get',
        params:data
    })
}

// 首页数据
export function home_index(data){
    return request({
        url: 'statistics/home_index',
        method: 'get',
        params: data
    })

}


// 统计数据

export function target_amount(data){
    return request({
        url: 'statistics/group_target_amount',
        method: 'get',
        params: data
    })
}


// 统计数据各组任务数据
export function team_target_amount(data){
    return request({
        url: 'statistics/team_target_amount',
        method: 'get',
        params:data
    })
}



/*
标签相关接口
 */
export function tags_list (data) {
    return request({
        url: 'system/tags',
        method: 'get',
        params: data
    })
}

export function tags_manager (data) {
    return request({
        url: 'system/tags_manager',
        method: 'post',
        data
    })
}

export function tags_del (data) {
    return request({
        url: 'system/tags_del',
        method: 'post',
        data
    })
}

export function tags_async (data) {
    return request({
        url: 'system/tags_async',
        method: 'post',
        data
    })
}

export function tags_select (data) {
    return request({
        url: 'system/tags_select',
        method: 'get',
        params:data
    })
}


// 修改顾客标签
export function set_customer_tag (data) {
    return request({
        url: 'system/set_tag',
        method: 'post',
        data
    })
}
// 获取城市数据
export function get_city_list (data) {
    return request({
        url: 'system/city',
        method: 'post',
        data
    })
}

// 保存企微配置
export function save_conf(data) {
    return request({
        url:'config/add',
        method:'post',
        data
    })
}


// 获取企微配置
export function get_conf() {
    return request({
        url:'config/get',
        method:'get'
    })
}


// 对接类型列表
export function dock_list (data) {
    return request({
        url: 'system/dock_list',
        method: 'get',
        params: data
    })
}


export function dock_type_list (data) {
    return request({
        url: 'system/dock_type_list',
        method: 'get',
        params: data
    })
}

export function dock_type_manager (data) {
    return request({
        url: 'system/dock_type_manager',
        method: 'post',
        data
    })
}
// 成交方式
export function dock_type_del (data) {
    return request({
        url: 'system/dock_type_del',
        method: 'post',
        data
    })
}

// 权限角色列表
export function power_select (data) {
    return request({
        url: 'company/power_select',
        method: 'post',
        data
    })
}
// 添加权限角色
export function add_power_department (data) {
    return request({
        url: 'company/add_power_department',
        method: 'post',
        data
    })
}

// 角色权限列表
export function power_department_list (data) {
    return request({
        url: 'company/power_department_list',
        method: 'post',
        data
    })
}
// 删除角色权限
export function del_power_department (data) {
    return request({
        url: 'company/del_power_department',
        method: 'post',
        data
    })
}

// 获取对接方式级联数据
export function get_dock_cascade_list (data) {
    return request({
        url: 'system/dock_cascade',
        method: 'get',
        params: data
    })
}


/*
订单产品相关接口
 */
// 删除
export function product_del (data) {
    return request({
        url: 'system/product_del',
        method: 'post',
        data
    })
}

// 增改
export function product_manager (data) {
    return request({
        url: 'system/product_manager',
        method: 'post',
        data
    })
}

export function product_page (data) {
    return request({
        url: 'system/product_page',
        method: 'get',
        params: data
    })
}

export function product_list (data) {
    return request({
        url: 'system/product_list',
        method: 'get',
        params: data
    })
}